import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import LoadingSpinnerxs from "../LoadingSpinner/LoadingSpinnerxs";

function SubscriberCountFilter(props) {
  const {
    submitQuery,
    defaultStartDate,
    defaultEndDate,
    isDataAvailable,
    isDownloading,
    handleDownload,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    serviceList = [],
    loadingServices = false,
  } = props;

  const [reportType, setReportType] = useState("");
  const [validationError, setValidationError] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [networkId, setNetworkId] = useState("");

  const filteredServiceList = networkId
    ? serviceList.filter((s) => String(s.network_id) === String(networkId))
    : serviceList;

  const handleNetworkChange = (e) => {
    setNetworkId(e.target.value);
    setServiceId("");
  };

  const formatDateForAPI = (date) => {
    if (!date) return "";
    return format(date, "dd-MM-yyyy");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!startDate) {
      setValidationError("Please select a start date");
      return;
    }

    if (!endDate) {
      setValidationError("Please select an end date");
      return;
    }

    if (endDate < startDate) {
      setValidationError("End date cannot be before start date");
      return;
    }

    if (!reportType) {
      setValidationError("Please select a report type");
      return;
    }

    setValidationError("");

    submitQuery(
      formatDateForAPI(startDate),
      formatDateForAPI(endDate),
      reportType,
      serviceId,
      networkId || "all",
    );
  };

  return (
    <div className="card mb-4 mt-25 p-5">
      <div className="row">
        {" "}
        {/* change card-body to row becauase of color */}
        <form
          onSubmit={handleSubmit}
          className={`row g-3 align-items-end ps-4 `}
        >
          <div className="col-12 col-sm-6 col-md-2">
            <DatePicker
              selected={startDate}
              className="filter_text form-padding"
              onChange={(date) => {
                setStartDate(date);
                setValidationError("");
              }}
              dateFormat="yyyy-MM-dd"
              isClearable
              placeholderText="Select start date"
              calendarClassName="large-calendar"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-2">
            <DatePicker
              minDate={startDate}
              selected={endDate}
              className="filter_text form-padding"
              onChange={(date) => {
                setEndDate(date);
                setValidationError("");
              }}
              dateFormat="yyyy-MM-dd"
              isClearable
              placeholderText="Select end date"
              calendarClassName="large-calendar"
              disabled={!startDate}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-2">
            <select
              id="reportType"
              className="filter_text form-padding"
              value={reportType}
              onChange={(e) => {
                setReportType(e.target.value);
                setValidationError("");
              }}
            >
              <option value="">Report Type</option>
              <option value="subscribers">Subscribers</option>
              <option value="unsubscribers">Unsubscribers</option>
            </select>
          </div>
          <div className="col-12 col-sm-6 col-md-2">
            <select
              className="filter_text form-padding"
              value={networkId}
              onChange={handleNetworkChange}
            >
              <option value="">-Network (All)-</option>
              <option value="1">MTN</option>
              <option value="2">GLO</option>
              <option value="3">Airtel</option>
              <option value="4">9Mobile</option>
            </select>
          </div>
          <div className="col-12 col-sm-6 col-md-2">
            <select
              className="filter_text form-padding"
              value={serviceId}
              onChange={(e) => setServiceId(e.target.value)}
              disabled={loadingServices}
              style={{ opacity: loadingServices ? 0.4 : 1 }}
            >
              <option value="">
                {loadingServices
                  ? "Loading..."
                  : `-Service (All)${filteredServiceList.length > 0 ? ` (${filteredServiceList.length})` : ""}-`}
              </option>
              {filteredServiceList.map((s, i) => (
                <option key={`${s.serviceId}_${i}`} value={s.serviceId}>
                  {s.serviceName}
                </option>
              ))}
            </select>
          </div>

          <div
            className={"col-12 col-sm-6 col-md-2"}
          >
            <button
              type="submit"
              className="btn btn-primary w-100 form-padding"
            >
              Filter
            </button>
          </div>

          <div className="col-12 col-sm-6 col-md-2">
            <button
              type="button"
              className="btn btn-primary w-100 form-padding"
              onClick={handleDownload}
              disabled={!isDataAvailable}
            >
              {isDownloading ? (
                <LoadingSpinnerxs />
              ) : (
                <i className="fa fa-download" />
              )}
            </button>
          </div>

          {/* <div className="col-md-">
                        <button type="submit" className="btn btn-primary w-100 form-padding"
                            style={{ marginLeft: 15 }}>
                            Filter
                        </button>
                    </div> */}

          {validationError && (
            <div className="col-12 mt-2 pl-30">
              <div className="alert alert-danger" role="alert">
                {validationError}
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default SubscriberCountFilter;
